import './collapse.css';

import React, { useState } from 'react';
import { Collapse } from 'react-collapse';

import { Container, Header, Script as Rows, Row, collapseTheme } from './styles';

import { useElement } from '../../hooks';

const Script = ({ script, defaultOpen = false }) => {
	const { getElementColor, parseElementName } = useElement();

	const [showScript, setShowScript] = useState(defaultOpen);
	const [hightlight, setHightlight] = useState(false);

	const handleToggleScriptCollapse = () => setShowScript(!showScript);

	const getVoicesQuantity = (script) => {
		const quantity = script.filter(({ type }) => type === 'OFF-MAIN').length;

		return (
			<>
				O modelo possui <strong>{quantity}</strong> offs
			</>
		);
	};

	const onMouseOver = () =>
		setTimeout(() => {
			setHightlight(true);
		}, 500);

	const onMouseOut = () => setHightlight(false);

	return (
		<Container>
			{!defaultOpen && (
				<Header>
					<div>
						<h3>{script.name}</h3>
						<span>{getVoicesQuantity(script.body)}</span>
					</div>
					<button onClick={handleToggleScriptCollapse}>
						{showScript ? 'Esconder Modelo' : 'Visualizar Modelo'}
					</button>
				</Header>
			)}
			<Collapse isOpened={showScript} theme={collapseTheme}>
				<Rows onMouseOver={onMouseOver} onMouseOut={onMouseOut} hightlight={hightlight}>
					{script.body.map((element, index) => (
						<Row
							key={index}
							color={getElementColor({ type: element.type })}
							isNewBlock={element?.type === 'NEW-BLOCK'}
							className={element?.type === 'OFF-MAIN' && 'voice'}>
							{parseElementName({ type: element?.type })}
						</Row>
					))}
				</Rows>
			</Collapse>
		</Container>
	);
};

export default Script;
